/* some Partners try to embed the site (against our advice) and use /join or
   /login to get the users to authenticate and connect their service but
   SSO doesn't work inside an iframe so we'll only provide the regular user/pass
   form
   note: this is unlikely to work in modern browsers where the parent frame has
   a different origin than ours
*/

export default function DetectIframeAndHideSSO() {
  const frameEl = window.frameElement
  const runningIntegrationTests = window.parent?.__Cypress__ === true

  if (
    frameEl && // in iframe
    ["/join", "/login"].includes(window.location.pathname) &&
    !runningIntegrationTests
  ) {
    if (
      window.location.search.indexOf("wp_=1") === -1 // showing SSO
    ) {
      frameEl.src = window.location.href + "?wp_=1" // go to user/pass form
    } else {
      document.querySelector('[data-action="sso-signup"]')?.remove()
    }
  }
}
